import { createContext, useContext } from "react";

// Tab Context and Components
const TabsContext = createContext(undefined);

export function Tabs({ value, onValueChange, children, className = "" }) {
  return (
    <TabsContext.Provider value={{ value, onValueChange }}>
      <div className={className}>{children}</div>
    </TabsContext.Provider>
  );
}

export function TabsList({ children, className = "" }) {
  const styles = `
    .custom-tabs-list {
      background: white;
      border-bottom: 1px solid #dee2e6;
      margin-bottom: 0;
      overflow-x: auto;
      overflow-y: hidden;
      -webkit-overflow-scrolling: touch;
      scrollbar-width: none;
      -ms-overflow-style: none;
      display: flex;
      flex-wrap: nowrap;
      padding-left: 0px;
      list-style: none;
      scroll-behavior: smooth;
    }

    .custom-tabs-list::-webkit-scrollbar {
      display: none;
    }

    .custom-tabs-list .nav-item {
      flex-shrink: 0;
    }

    .custom-tabs-list .nav-link {
      display: flex;
      align-items: center;
      padding: 8px 15px;
      border: none;
      background: transparent;
      color: #6c757d;
      text-decoration: none;
      font-weight: 500;
      font-size: 14px;
      border-bottom: 2px solid transparent;
      transition: all 0.2s ease;
      white-space: nowrap;
      cursor: pointer;
      border-radius: 0;
    }

    .custom-tabs-list .nav-link:hover {
      color: #495057;
      border-bottom-color: #dee2e6;
      background: transparent;
    }

    .custom-tabs-list .nav-link.active {
      color: #001529;
      border-bottom-color: #001529;
      background: transparent;
    }

    .custom-tabs-list .nav-link:focus {
    //   outline: 2px solid #007bff;
      outline-offset: -2px;
      box-shadow: none;
    }

    .custom-tab-icon {
      margin-right: 8px;
      font-size: 16px;
    }

    /* Mobile specific styles */
    @media (max-width: 767.98px) {
      .custom-tabs-list {
        // padding-left: 16px;
        padding-right: 16px;
      }
      
      .custom-tabs-list .nav-link {
        padding: 12px 16px;
        font-size: 13px;
      }
      
      .custom-tab-icon {
        font-size: 14px;
        margin-right: 6px;
      }
    }

    /* Desktop specific styles */
    @media (min-width: 768px) {
      .custom-tabs-list {
        // padding-left: 24px;
        padding-right: 24px;
      }
    }
  `;

  return (
    <>
      <style>{styles}</style>
      <ul className={`custom-tabs-list ${className}`} role="tablist">
        {children}
      </ul>
    </>
  );
}

export function TabsTrigger({ value, children, className = "" }) {
  const context = useContext(TabsContext);
  if (!context) throw new Error("TabsTrigger must be used within Tabs");

  const isActive = context.value === value;

  return (
    <li className="nav-item" role="presentation">
      <button
        className={`nav-link ${isActive ? "active" : ""} ${className}`}
        type="button"
        role="tab"
        onClick={() => context.onValueChange(value)}
      >
        {children}
      </button>
    </li>
  );
}

export function TabsContent({ value, children, className = "" }) {
  const context = useContext(TabsContext);
  if (!context) throw new Error("TabsContent must be used within Tabs");

  if (context.value !== value) return null;

  return (
    <div
      className={`tab-pane fade show active mt-3 ${className}`}
      role="tabpanel"
    >
      {children}
    </div>
  );
}
